document.addEventListener('DOMContentLoaded', () => {
  const playersGridContainer = document.getElementById('playersGridContainer');
  if (!playersGridContainer) {
    return;
  }

  const saveRosterBtn = document.getElementById('saveRosterBtn');
  const rosterForm = document.getElementById('rosterForm');
  const loadMoreBtn = document.getElementById('loadMorePlayers');
  const playersContainer = document.getElementById('playersContainer');
  const paginationDataEl = document.getElementById('playersPaginationData');
  const seasonSelect = document.getElementById('seasonSelect');

  if (seasonSelect) {
    if (window.jQuery && window.jQuery.fn.select2) {
      setTimeout(() => {
        const $select = window.jQuery(seasonSelect);
        $select.off('change').on('change', function(e) {
          handleSeasonChange(e);
        });
      }, 500);
    } else {
      seasonSelect.addEventListener('change', handleSeasonChange);
    }
  }

  if (saveRosterBtn && rosterForm) {
    const defaultButtonContent = saveRosterBtn.dataset.defaultText || saveRosterBtn.textContent;
    const loadingButtonText = saveRosterBtn.dataset.loadingText || 'Saving...';
    const errorMessage = saveRosterBtn.dataset.errorText || 'Error updating roster';

    saveRosterBtn.addEventListener('click', () => {
      saveRosterBtn.disabled = true;
      saveRosterBtn.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> ${loadingButtonText}`;

      const formData = new FormData(rosterForm);
      const csrfMeta = document.querySelector('meta[name="csrf-token"]');
      const csrfToken = csrfMeta ? csrfMeta.getAttribute('content') : null;

      const headers = {
        'X-Requested-With': 'XMLHttpRequest'
      };

      if (csrfToken) {
        headers['X-CSRF-Token'] = csrfToken;
      }

      const request = fetch(rosterForm.action, {
        method: 'POST',
        body: formData,
        headers
      });

      // This is fetch (not axios), so the global axios interceptor does NOT fire.
      // handleJsonResponse displays the server-rendered success/error message itself.
      window.TeamforceNotifications.handleJsonResponse(request, {
        onSuccess: () => {
          if (window.jQuery && typeof window.jQuery('#rosterModal').modal === 'function') {
            window.jQuery('#rosterModal').modal('hide');
          }
          window.location.reload();
        }
      }).catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error:', error);
        window.showNotification(errorMessage, 'error');
      }).finally(() => {
        saveRosterBtn.disabled = false;
        saveRosterBtn.innerHTML = defaultButtonContent;
      });
    });
  }

  if (loadMoreBtn && playersContainer && paginationDataEl) {
    initLoadMoreButton();
  }
});

function initLoadMoreButton() {
  const btn = document.getElementById('loadMorePlayers');
  const container = document.getElementById('playersContainer');
  const paginationData = document.getElementById('playersPaginationData');

  if (!btn || !container || !paginationData) return;

  const newBtn = btn.cloneNode(true);
  btn.parentNode.replaceChild(newBtn, btn);

  newBtn.addEventListener('click', () => {
    const nextPage = paginationData.dataset.nextPage;
    if (!nextPage) return;

    newBtn.disabled = true;
    const originalText = newBtn.textContent;
    newBtn.textContent = `${originalText}...`;

    const url = new URL(window.location.href);
    url.searchParams.set('page', nextPage);

    fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then((response) => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newItems = doc.querySelectorAll('#playersContainer > *');

        newItems.forEach((node) => {
          container.appendChild(node);
        });

        const newPaginationData = doc.getElementById('playersPaginationData');
        if (newPaginationData && newPaginationData.dataset.nextPage) {
          paginationData.dataset.nextPage = newPaginationData.dataset.nextPage;
        } else if (newBtn.parentNode) {
          newBtn.parentNode.removeChild(newBtn);
        }
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error loading more players:', error);
        const msg = newBtn.dataset.errorText || (window.document.body.dataset.i18nRequestFailed || 'Request failed.');
        window.showNotification(msg, 'error');
      })
      .finally(() => {
        if (document.getElementById('loadMorePlayers')) {
          newBtn.disabled = false;
          newBtn.textContent = originalText;
        }
      });
  });
}

function handleSeasonChange(e) {
  const container = document.getElementById('playersGridContainer');
  if (!container) return;

  const loadingStartTime = Date.now();
  showLoadingOverlay(container);

  const seasonValue = e.target ? e.target.value : e.val;

  const url = new URL(window.location.href);
  url.searchParams.set('season_id', seasonValue);
  url.searchParams.delete('page');

  fetch(url.toString(), {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'text/javascript'
    }
  })
    .then((response) => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.text();
    })
    .then((html) => {
      container.innerHTML = html;
      window.history.pushState({}, '', url);

      const newLoadMoreBtn = document.getElementById('loadMorePlayers');
      if (newLoadMoreBtn) {
        initLoadMoreButton();
      }
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Error loading players:', error);
      const msg = (container.dataset && container.dataset.errorText) || 'Error loading players. Please try again.';
      window.showNotification(msg, 'error');
    })
    .finally(() => {
      const loadingDuration = Date.now() - loadingStartTime;
      const minDisplayTime = 300;
      const remainingTime = Math.max(0, minDisplayTime - loadingDuration);

      setTimeout(() => {
        hideLoadingOverlay(container);
      }, remainingTime);
    });
}

function showLoadingOverlay(container) {
  const overlay = document.createElement('div');
  overlay.className = 'loading-overlay';
  overlay.innerHTML = `
    <div class="text-center">
      <div class="spinner-border" role="status" style="width: 3rem; height: 3rem; border-width: 0.3rem;">
        <span class="sr-only">Loading...</span>
      </div>
      <div style="margin-top: 1rem; font-size: 1.2rem; font-weight: bold; color: var(--main-color, #007bff);">
        Loading...
      </div>
    </div>
  `;
  container.style.position = 'relative';
  container.appendChild(overlay);
}

function hideLoadingOverlay(container) {
  const overlay = container.querySelector('.loading-overlay');
  if (overlay) {
    overlay.remove();
  }
}
